import { http, HttpResponse, delay, passthrough } from "msw";
import config from "../shared/config/config";
const GATEWAY_URL = config.servers.gateway.url;

const rx = (p: string) => new RegExp(`^(https?:\\/\\/[^/]+)?${p}\\/?$`);

// 필요하면 실제 타입으로 교체: import type { ConfigDto } from '...';
let config_data /* : ConfigDto */ = {
  externalUserViewType: "MY_LIST",
  webOfficeAllowUserType: "ALL",
  restorePermission: "ALL",
  unwrappingPermission: "MASTER",
  watermark: "ALL",
  webOfficeType: "COLLABORA",
  fileUploadMaxSizeMB: 300,
  fileUploadConfigMaxSizeMB: 0,
  licenseAlertPercentage: 80,
  sentMail: false,
  lastUpdateTime: 1761526801159,
  companyName: null,
  serviceType: "CLOUD",
  allowMobile: true,
  allowMacOS: true,
  watermarkPattern:
    "${username}(${userid}) / ${contentname} / ${currenttime} / aaa",
  workgroupCreatePermission: "INTERNAL",
  workgroupHeadSelectPermission: "@@WORKGROUPCREATOR",
  workgroupTreeViewPermission: "ALL",
  workgroupTreeCreatePermission: "MASTER",
  fileUploadPermission: "EXTERNAL",
  fileOwnerSelectPermission: "FILEUPLOADER",
  autoUnwrappingPermission: false,
  activeHtmlWrapping: true,
  userOtpType: "USE_SEPARATE_SETTING",
  internalUserOtpType: "NONE",
  externalUserOtpType: "NONE",
  watermarkTop: 59,
  watermarkFontSize: 16,
  watermarkOpacity: 0.2,
  watermarkRotate: 30,
  supportMobileAppTypeListStr: "origin,online",
  folderMoveOwner: true,
  folderMoveAllowType: "MASTER",
  workgroupPermission: "",
  workgroupPermissionDTO: {
    changeCode: "CREATE",
    uniqueId: null,
    workgroupCode: null,
    syncId: "NONE",
    targetType: "WORKGROUP",
    targetValue: null,
    authType: "LOGIN",
    policyType: "TEMPLATE",
    policyCode: null,
    updateTime: 1,
    createUser: "",
    updateUser: "",
    policy: {
      startTime: 0,
      allowDays: 61,
      allowDaysTimeZone: 9.0,
      allowViewCount: 20,
      currentViewCount: 0,
      allowDownloadCount: 0,
      currentDownloadCount: 0,
      drmPerm: [],
      webView: true,
      revision: true,
      download: true,
      wrapping: true,
      additionalViewPermission: "NONE",
      fileShareLinkPolicy: {
        authType: "LOGIN",
        password: "",
        urlAction: "DOWNLOAD",
        allowDays: 61,
        allowDaysTimeZone: 0.0,
      },
      notificationPolicy: null,
    },
  },
  chatAvailibility: null,
  chatServiceUrl: null,
  aiDocumentChatAvailibility: null,
  aiDocumentChatServiceApiUrl: null,
  manualRevisionExtensionsListStr: null,
  notificationPreferencePolicy: "",
  notificationPreferencePolicyDTO: {
    usingWorkgroupInvitedAlert: true,
    usingFileAlert: true,
    fileAlert: ["fileshare", "memo", "revision"],
    usingReadRequestAlert: true,
    readRequestAlert: ["readRequest", "readRequestConfirm"],
  },
  applicationPlatformPolicy: "",
  applicationPlatformPolicyDTO: {
    ios: { applicationDocumentViewerType: "WEBOFFICE" },
    android: { applicationDocumentViewerType: "WEBOFFICE" },
    macos: { applicationDocumentViewerType: "WEBOFFICE" },
    windows: { applicationDocumentViewerType: "WEBOFFICE" },
  },
  allowLiteExternal: true,
  displayLiteExternalPolicy: true,
  noneWorkGroupPolicy: "",
  noneWorkGroupPolicyDTO: {
    changeCode: null,
    uniqueId: null,
    workgroupCode: "NONEWORKGROUP",
    syncId: "NONE",
    targetType: "USER",
    targetValue: null,
    authType: "LOGIN",
    policyType: "TEMPLATE",
    policyCode: null,
    updateTime: 1,
    createUser: "",
    updateUser: "",
    policy: {
      startTime: 0,
      allowDays: 20,
      allowDaysTimeZone: 9.0,
      allowViewCount: 0,
      currentViewCount: 0,
      allowDownloadCount: 0,
      currentDownloadCount: 0,
      drmPerm: ["print_screen", "print", "view"],
      revision: true,
      download: true,
      wrapping: true,
      additionalViewPermission: "NONE",
      fileShareLinkPolicy: {
        authType: "LOGIN",
        password: "",
        urlAction: "DOWNLOAD",
        allowDays: 61,
        allowDaysTimeZone: 0.0,
      },
      notificationPolicy: null,
    },
    companyName: null,
    deptName: null,
    userType: 2,
    status: 2,
    userName: null,
    phoneNumber: null,
  },
};
let file_usage_admin_log = {
  logResults: [
    {
      logId: "202510300122598851f0078a6946a5b37e290168f490d5",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761787379239,
      entryDate: 1761787379000,
      syncId: "20251030012258535e15d9ac734cf6b525943475ab7148",
      documnetName: "AAAAAAAAAAAAAAAAAAAAAA.jpg",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025103001225862629928cd7b46e182a3785a375c8f03",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761787378820,
      entryDate: 1761787378000,
      syncId: "20251030012258535e15d9ac734cf6b525943475ab7148",
      documnetName: "B.jpg",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "B.jpg",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: "서보경(bkseo3)",
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "127b09fcca7447f3920d2de4b6fa9060",
            workgroupCode: "NONEWORKGROUP",
            syncId: "20251030012258535e15d9ac734cf6b525943475ab7148",
            targetType: "USER",
            targetValue: "bkseo3",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "127b09fcca7447f3920d2de4b6fa9060",
            updateTime: 1,
            createUser: "kkjuyeon",
            updateUser: "kkjuyeon",
            policy: {
              startTime: 1761787378751,
              allowDays: 61,
              allowDaysTimeZone: 9,
              allowViewCount: 5,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: null,
              webView: true,
              revision: false,
              download: true,
              wrapping: false,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "LOGIN",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: 61,
                allowDaysTimeZone: 0,
              },
              notificationPolicy: null,
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251030005329cdd01a65012e4cc1be122002317d46eb",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "fa0bc040fb5140888d327d40acf11de0",
      workgroupName:
        "이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "link",
      actionTypeDbValue: "link",
      logDatas: null,
      logData: null,
      logDate: 1761785609588,
      entryDate: 1761785609000,
      syncId: "20250806073556377a8517dda14aab953b1b81cee43bbe",
      documnetName: "치킨의 효능 (1) (1).docx",
      result: null,
      status: null,
      saveType: 10,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: null,
            uniqueId: null,
            workgroupCode: null,
            syncId: null,
            targetType: null,
            targetValue: null,
            authType: null,
            policyType: null,
            policyCode: null,
            updateTime: 0,
            createUser: null,
            updateUser: null,
            policy: {
              startTime: 0,
              allowDays: 0,
              allowDaysTimeZone: 0,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: null,
              webView: false,
              revision: false,
              download: false,
              wrapping: false,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: null,
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510300053282c624be3cc0d44f8adca499b60aabf79",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "fa0bc040fb5140888d327d40acf11de0",
      workgroupName:
        "이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "link",
      actionTypeDbValue: "link",
      logDatas: null,
      logData: null,
      logDate: 1761785608775,
      entryDate: 1761785608000,
      syncId: "20250806073556377a8517dda14aab953b1b81cee43bbe",
      documnetName: "치킨의 효능 (1) (1).docx",
      result: null,
      status: null,
      saveType: 10,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: null,
            uniqueId: null,
            workgroupCode: null,
            syncId: null,
            targetType: null,
            targetValue: null,
            authType: null,
            policyType: null,
            policyCode: null,
            updateTime: 0,
            createUser: null,
            updateUser: null,
            policy: {
              startTime: 0,
              allowDays: 0,
              allowDaysTimeZone: 0,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: null,
              webView: false,
              revision: false,
              download: false,
              wrapping: false,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "LOGIN",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: null,
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102905431089376680cfda436eb0c15a831477ff85",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761716590571,
      entryDate: 1761716590000,
      syncId: "2025102805545824461bc50fdc4b1e95e9fe3f635e9c74",
      documnetName: "wordtopdffile.pdf",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510282351153d05dc047b104edbba2c6834f89cf817",
      userId: "bkseo",
      userName: "서보경",
      workgroupId: "8513d488d15b43fe97d5c8bc74d68c42",
      workgroupName: "테스트트트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "view",
      actionTypeDbValue: "view",
      logDatas: null,
      logData: null,
      logDate: 1761695475000,
      entryDate: 1761695475000,
      syncId: "20251028234717a42f244a88894abdacb7699d9f24930f",
      documnetName: "12345.docx",
      result: null,
      status: null,
      saveType: 7,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Safari-18.4",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028235112f1ada874cc2049ae96f20832981d316b",
      userId: "bkseo",
      userName: "서보경",
      workgroupId: "8513d488d15b43fe97d5c8bc74d68c42",
      workgroupName: "테스트트트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "view",
      actionTypeDbValue: "view",
      logDatas: null,
      logData: null,
      logDate: 1761695471000,
      entryDate: 1761695472000,
      syncId: "20251028234717a42f244a88894abdacb7699d9f24930f",
      documnetName: "12345.docx",
      result: null,
      status: null,
      saveType: 7,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Safari-18.4",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510282351043267e1de18ab45c5b9c87d703f73dd61",
      userId: "bkseo",
      userName: "서보경",
      workgroupId: "8513d488d15b43fe97d5c8bc74d68c42",
      workgroupName: "테스트트트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "change",
      actionTypeDbValue: "change",
      logDatas: null,
      logData: null,
      logDate: 1761695464545,
      entryDate: 1761695464000,
      syncId: "20251028234717a42f244a88894abdacb7699d9f24930f",
      documnetName: "12345.docx",
      result: null,
      status: null,
      saveType: 3,
      historyType: 1,
      revisionNo: 1,
      desc: "test5 (2).docx",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Safari-18.4",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028234719d70625eedcd8434dbcf6c157189b1f54",
      userId: "bkseo",
      userName: "서보경",
      workgroupId: "8513d488d15b43fe97d5c8bc74d68c42",
      workgroupName: "테스트트트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761695239992,
      entryDate: 1761695240000,
      syncId: "20251028234717a42f244a88894abdacb7699d9f24930f",
      documnetName: "test5 (2).docx",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Mac-UnKnown",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028234718a4d6135b1e95464d9679cfb9331403cb",
      userId: "bkseo",
      userName: "서보경",
      workgroupId: "8513d488d15b43fe97d5c8bc74d68c42",
      workgroupName: "테스트트트",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761695238645,
      entryDate: 1761695238000,
      syncId: "20251028234717a42f244a88894abdacb7699d9f24930f",
      documnetName: "test5 (2).docx",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "test5 (2).docx",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Mac-UnKnown",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "59db5463cc494a7bb23188523171c6eb",
            workgroupCode: "8513d488d15b43fe97d5c8bc74d68c42",
            syncId: "20251028234717a42f244a88894abdacb7699d9f24930f",
            targetType: "WORKGROUP",
            targetValue: "8513d488d15b43fe97d5c8bc74d68c42",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "536154b071f3424a989c86d7ab5931f9",
            updateTime: 0,
            createUser: "bkseo",
            updateUser: "bkseo",
            policy: {
              startTime: 1761695237140,
              allowDays: 61,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: [],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "LOGIN",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: 61,
                allowDaysTimeZone: 0,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: true,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequest", "readRequestConfirm"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028091435b2ab0963819a4093af5a0f13d480fb1f",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642875524,
      entryDate: 1761642875000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914322a02446443e44e41bacd02067a138c45",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642872270,
      entryDate: 1761642872000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914289a7df4b604e54f1dafefd4cf2b5e5edc",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642868050,
      entryDate: 1761642868000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914213d9f1942c9a74caba14c8bf2c9fe8617",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642861345,
      entryDate: 1761642861000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028091414fe590e9f912e4b72b153d45f2d486be9",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642854728,
      entryDate: 1761642854000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028091411401f001c830b4360825ce8129b83e85d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "view",
      actionTypeDbValue: "view",
      logDatas: null,
      logData: null,
      logDate: 1761642851000,
      entryDate: 1761642851000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 7,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914062e903f835e1f48e2b1bc6bb3083aa06d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642846395,
      entryDate: 1761642846000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028085324cd1444b8b3464b46adf20d9635d77d21",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761641604961,
      entryDate: 1761641604000,
      syncId: "202510240800581afb858aca654f23a92d024675e09e9e",
      documnetName: "output.xlsx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280802368b3873ff067b45d69a1ee041102c503a",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "96abb13e1fc14e6680efe840a4683937",
      workgroupName: "애드인 테스트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "view",
      actionTypeDbValue: "view",
      logDatas: null,
      logData: null,
      logDate: 1761638556000,
      entryDate: 1761638556000,
      syncId: "202510280802146a27b15011a34e3390a7a5dd7a354ca7",
      documnetName: "test.txt",
      result: null,
      status: null,
      saveType: 7,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102808021637b9d5c31da340dea74c0873fc95b06e",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "96abb13e1fc14e6680efe840a4683937",
      workgroupName: "애드인 테스트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761638536137,
      entryDate: 1761638536000,
      syncId: "202510280802146a27b15011a34e3390a7a5dd7a354ca7",
      documnetName: "test.txt",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280802151ab6fb1749db4d899f5f5dd43e01e5ab",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "96abb13e1fc14e6680efe840a4683937",
      workgroupName: "애드인 테스트",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761638535112,
      entryDate: 1761638535000,
      syncId: "202510280802146a27b15011a34e3390a7a5dd7a354ca7",
      documnetName: "test.txt",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "test.txt",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "0466e830d4344039bafb9cfe3bd68222",
            workgroupCode: "96abb13e1fc14e6680efe840a4683937",
            syncId: "202510280802146a27b15011a34e3390a7a5dd7a354ca7",
            targetType: "WORKGROUP",
            targetValue: "96abb13e1fc14e6680efe840a4683937",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "798712bab194466d8bc1d1271d461929",
            updateTime: 0,
            createUser: "kkjuyeon",
            updateUser: "kkjuyeon",
            policy: {
              startTime: 1760593149317,
              allowDays: 61,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: [],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "LOGIN",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: 61,
                allowDaysTimeZone: 0,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: true,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequest", "readRequestConfirm"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280748370b282e3f98dd4f80af6db6728a211386",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "96abb13e1fc14e6680efe840a4683937",
      workgroupName: "애드인 테스트",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761637717949,
      entryDate: 1761637717000,
      syncId: "20251028074835624e7cf57de547d98593f7a3782471f7",
      documnetName: "B (2).jpg",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102807483602fddef7459448cbae08cac20a722f51",
      userId: "kkjuyeon",
      userName: "주연",
      workgroupId: "96abb13e1fc14e6680efe840a4683937",
      workgroupName: "애드인 테스트",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761637716955,
      entryDate: 1761637716000,
      syncId: "20251028074835624e7cf57de547d98593f7a3782471f7",
      documnetName: "B (2).jpg",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "B (2).jpg",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "1b26f3dbae5847bf91cd8962d94c6b6d",
            workgroupCode: "96abb13e1fc14e6680efe840a4683937",
            syncId: "20251028074835624e7cf57de547d98593f7a3782471f7",
            targetType: "WORKGROUP",
            targetValue: "96abb13e1fc14e6680efe840a4683937",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "798712bab194466d8bc1d1271d461929",
            updateTime: 0,
            createUser: "kkjuyeon",
            updateUser: "kkjuyeon",
            policy: {
              startTime: 1760593149317,
              allowDays: 61,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: [],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "LOGIN",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: 61,
                allowDaysTimeZone: 0,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: true,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequest", "readRequestConfirm"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556103f1f10497a7247689929990acd496df2",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630970080,
      entryDate: 1761630970000,
      syncId: "20251028055459a1e8a7df072c49eb95e93cd4b310193a",
      documnetName: "2024년+생활시간조사+실시+알림+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556098693d951e7e1413e822753561a6e8727",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630969564,
      entryDate: 1761630969000,
      syncId: "20251028055459417f0a554d814b72bfa69b6562a922d1",
      documnetName: "2023년+봄감자+생산량조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055609d2ba50c59e0d4617aa3ac7d20b0abd6b",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630969065,
      entryDate: 1761630969000,
      syncId: "20251028055459c82f1e81af3e439a9792a6d33e2220bb",
      documnetName: "2024년+생활시간조사+실시+정책홍보+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055608e7696b9e5bab4bd6b52ff04082d584ae",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630968532,
      entryDate: 1761630968000,
      syncId: "20251028055459df54d1aa5ddd45d4a9449c7711007d73",
      documnetName:
        "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료) (1).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102805560890d117fd472c40feb118f41db4c80478",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630968002,
      entryDate: 1761630968000,
      syncId: "20251028055459ad01f8ed997b4b6eafebf93e2e25723e",
      documnetName: "2023년+전국사업체조사+조사실시+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556075cb8c21220db4548a8fc1af8bbbfdd59",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630967476,
      entryDate: 1761630967000,
      syncId: "2025102805545928e8493f37464567965dc09b3993ddc9",
      documnetName:
        "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055606f2965d7233d145e89a27fd3faa4badd5",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630966940,
      entryDate: 1761630966000,
      syncId: "202510280554591319231472b5418883984115b8f94839",
      documnetName:
        "[통계청]+생활인구통계,+인구감소지역+전체로+확대(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556066130a71d044f4612a167128ca5f44131",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630966416,
      entryDate: 1761630966000,
      syncId: "202510280554584715bff0b3cf4c1b9bc09173ac13f878",
      documnetName: "2023년+맥류+봄감자+사과+배+재배면적조사+결과.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055605754efc196df846bba239e4206d6e070d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630965868,
      entryDate: 1761630965000,
      syncId: "20251028055458c6b0379de5cd40489aec615b4936f41d",
      documnetName: "한국표준산업분류+제11차+개정+보도자료(최종안).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055605ad662d226526444ebf0fe3e3008185a7",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630965184,
      entryDate: 1761630965000,
      syncId: "202510280554586bc5c09bbf50422b942e99aeb99af516",
      documnetName: "2023년+맥류+봄감자+사과+배+재배면적조사+결과 (1).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556043e1919eec15a4e309d8ba15662ae44e3",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630964586,
      entryDate: 1761630964000,
      syncId: "20251028055458e9f086580f4e4fb4a3c9847eba1fbf22",
      documnetName:
        "2022년+통계업무+진흥유공(통계조사+부문)+포상수여식(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556049eb6dc25d25948aea1e359ab1903fb93",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630964119,
      entryDate: 1761630964000,
      syncId: "2025102805545837023de4c762400d9665b61c9f5348be",
      documnetName:
        "[통계청]+통계청+수출+빅데이터+제공+및+해외통계데이터+수집+제공으로+기업+지원+가속화(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556038a5a3b6580554a0aaf55c47648ee9f30",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630963634,
      entryDate: 1761630963000,
      syncId: "202510280554583b52161935a742628ea4170536f7bdee",
      documnetName: "2023년+가을배추+무+재배면적조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556037d09b54607c9492fb5812b1e239da2de",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630963163,
      entryDate: 1761630963000,
      syncId: "202510280554580b1faa6d4a33401688009e11cdce4da2",
      documnetName: "보도자료(제22회+통계청+논문+공모전+개최).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556024ac29f3210f44d2fbc08491a615475c2",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630962677,
      entryDate: 1761630962000,
      syncId: "2025102805545802d7d653365a4d42a528214b02c11a23",
      documnetName: "2023년+벼+고추+재배면적조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055602ae81e9f19c094a0b8f0bb259de1183e3",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630962169,
      entryDate: 1761630962000,
      syncId: "202510280554587d1e30c2b585449c83d78255b920b8e1",
      documnetName: "ssec2310(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055601a31d12a47a734c7682e6df3ab3ea32d1",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630961675,
      entryDate: 1761630961000,
      syncId: "20251028055458c7e03f01083549289d1cfc4aeaee7f11",
      documnetName: "ssec2311(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556019ffdcae1e56d44fc94ef58662817df2e",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630961183,
      entryDate: 1761630961000,
      syncId: "20251028055458a6c24ddc65b242e5b80c1851cd522fcc",
      documnetName: "ssec2401(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055600df45bb803546466da89ec153b6034ab7",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630960686,
      entryDate: 1761630960000,
      syncId: "2025102805545824461bc50fdc4b1e95e9fe3f635e9c74",
      documnetName: "wordtopdffile.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055600c22dab9d290e4d0d9867852d996a2892",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630960195,
      entryDate: 1761630960000,
      syncId: "2025102805545893e6ca2c1212414c86426f4ac450d691",
      documnetName: "file-sample_150kB.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055559ba5c574d807a48d48610a3ddd90d797e",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630959658,
      entryDate: 1761630959000,
      syncId: "20251028055458263051ff82274f8781874fb286842b6e",
      documnetName: "ssec2402(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055559bf30fd39c2d7427f992c3f988de4b965",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630959205,
      entryDate: 1761630959000,
      syncId: "2025102805545826d9b1319fc6434a935cd45ea474be24",
      documnetName: "ssec2309(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055558e07d5dd03dc94cbfa889693ee57fa191",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630958755,
      entryDate: 1761630958000,
      syncId: "20251028055458138e5533122f481da9be5de0a15717e7",
      documnetName: "분기+GRDP+개발_정책홍보+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555585f7566d89e1042948ab46c1a34023499",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630958301,
      entryDate: 1761630958000,
      syncId: "202510280554587e3bbbcc64284e14aa27eaf18f264219",
      documnetName: "종로구관철동프라움스테이_주택사진.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055557e49b10a92028428caf4e198f06ed33cd",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630957837,
      entryDate: 1761630957000,
      syncId: "2025102805545851c2b2631fa64d7c88a338d4b45c8168",
      documnetName: "보도자료(KOSTAT+통계플러스+겨을호+발간+사전+배포).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055557098c0d3bf8e94987af4a850ed6bb02a9",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630957362,
      entryDate: 1761630957000,
      syncId: "20251028055458d70801e1ff1b4b1dbc5ca0fc2fa6d7a7",
      documnetName:
        "지방소멸+대응을+위한+지역+인구+100년+추계+제공+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055556e730db54fb5a471bb2ac736eee92d1c8",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630956906,
      entryDate: 1761630956000,
      syncId: "2025102805545854087ede25f648f5bd0ce34ebbdc46f1",
      documnetName:
        "통계청.+국가통계+특화형+개인정보+안심구역+운영한다(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
  ],
  total: 741,
  logId: null,
  lastLogId: "20251028055556e730db54fb5a471bb2ac736eee92d1c8",
  pageTotal: 50,
  posPage: 1,
  pageRange: 1,
  rowRange: 50,
};
const file_usage_user_log = {
  logResults: [
    {
      logId: "20251030005329cdd01a65012e4cc1be122002317d46eb",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "fa0bc040fb5140888d327d40acf11de0",
      workgroupName:
        "이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "link",
      actionTypeDbValue: "link",
      logDatas: null,
      logData: null,
      logDate: 1761785609588,
      entryDate: 1761785609000,
      syncId: "20250806073556377a8517dda14aab953b1b81cee43bbe",
      documnetName: "치킨의 효능 (1) (1).docx",
      result: null,
      status: null,
      saveType: 10,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: null,
            uniqueId: null,
            workgroupCode: null,
            syncId: null,
            targetType: null,
            targetValue: null,
            authType: null,
            policyType: null,
            policyCode: null,
            updateTime: 0,
            createUser: null,
            updateUser: null,
            policy: {
              startTime: 0,
              allowDays: 0,
              allowDaysTimeZone: 0,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: null,
              webView: false,
              revision: false,
              download: false,
              wrapping: false,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: null,
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510300053282c624be3cc0d44f8adca499b60aabf79",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "fa0bc040fb5140888d327d40acf11de0",
      workgroupName:
        "이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "link",
      actionTypeDbValue: "link",
      logDatas: null,
      logData: null,
      logDate: 1761785608775,
      entryDate: 1761785608000,
      syncId: "20250806073556377a8517dda14aab953b1b81cee43bbe",
      documnetName: "치킨의 효능 (1) (1).docx",
      result: null,
      status: null,
      saveType: 10,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: null,
            uniqueId: null,
            workgroupCode: null,
            syncId: null,
            targetType: null,
            targetValue: null,
            authType: null,
            policyType: null,
            policyCode: null,
            updateTime: 0,
            createUser: null,
            updateUser: null,
            policy: {
              startTime: 0,
              allowDays: 0,
              allowDaysTimeZone: 0,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: null,
              webView: false,
              revision: false,
              download: false,
              wrapping: false,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "LOGIN",
                password: "",
                urlAction: "DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: null,
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102905431089376680cfda436eb0c15a831477ff85",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761716590571,
      entryDate: 1761716590000,
      syncId: "2025102805545824461bc50fdc4b1e95e9fe3f635e9c74",
      documnetName: "wordtopdffile.pdf",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028091435b2ab0963819a4093af5a0f13d480fb1f",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642875524,
      entryDate: 1761642875000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914322a02446443e44e41bacd02067a138c45",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642872270,
      entryDate: 1761642872000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914289a7df4b604e54f1dafefd4cf2b5e5edc",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642868050,
      entryDate: 1761642868000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914213d9f1942c9a74caba14c8bf2c9fe8617",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642861345,
      entryDate: 1761642861000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028091414fe590e9f912e4b72b153d45f2d486be9",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642854728,
      entryDate: 1761642854000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028091411401f001c830b4360825ce8129b83e85d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "view",
      actionTypeDbValue: "view",
      logDatas: null,
      logData: null,
      logDate: 1761642851000,
      entryDate: 1761642851000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 7,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280914062e903f835e1f48e2b1bc6bb3083aa06d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761642846395,
      entryDate: 1761642846000,
      syncId: "2025091006455846c6a4783ccf46a2af798a4ccccad700",
      documnetName: "기본 정보 메시지.docx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028085324cd1444b8b3464b46adf20d9635d77d21",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "NONEWORKGROUP",
      workgroupName: "NONEWORKGROUP",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "download",
      actionTypeDbValue: "download",
      logDatas: null,
      logData: null,
      logDate: 1761641604961,
      entryDate: 1761641604000,
      syncId: "202510240800581afb858aca654f23a92d024675e09e9e",
      documnetName: "output.xlsx",
      result: null,
      status: null,
      saveType: 5,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556103f1f10497a7247689929990acd496df2",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630970080,
      entryDate: 1761630970000,
      syncId: "20251028055459a1e8a7df072c49eb95e93cd4b310193a",
      documnetName: "2024년+생활시간조사+실시+알림+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556098693d951e7e1413e822753561a6e8727",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630969564,
      entryDate: 1761630969000,
      syncId: "20251028055459417f0a554d814b72bfa69b6562a922d1",
      documnetName: "2023년+봄감자+생산량조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055609d2ba50c59e0d4617aa3ac7d20b0abd6b",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630969065,
      entryDate: 1761630969000,
      syncId: "20251028055459c82f1e81af3e439a9792a6d33e2220bb",
      documnetName: "2024년+생활시간조사+실시+정책홍보+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055608e7696b9e5bab4bd6b52ff04082d584ae",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630968532,
      entryDate: 1761630968000,
      syncId: "20251028055459df54d1aa5ddd45d4a9449c7711007d73",
      documnetName:
        "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료) (1).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102805560890d117fd472c40feb118f41db4c80478",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630968002,
      entryDate: 1761630968000,
      syncId: "20251028055459ad01f8ed997b4b6eafebf93e2e25723e",
      documnetName: "2023년+전국사업체조사+조사실시+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556075cb8c21220db4548a8fc1af8bbbfdd59",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630967476,
      entryDate: 1761630967000,
      syncId: "2025102805545928e8493f37464567965dc09b3993ddc9",
      documnetName:
        "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055606f2965d7233d145e89a27fd3faa4badd5",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630966940,
      entryDate: 1761630966000,
      syncId: "202510280554591319231472b5418883984115b8f94839",
      documnetName:
        "[통계청]+생활인구통계,+인구감소지역+전체로+확대(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556066130a71d044f4612a167128ca5f44131",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630966416,
      entryDate: 1761630966000,
      syncId: "202510280554584715bff0b3cf4c1b9bc09173ac13f878",
      documnetName: "2023년+맥류+봄감자+사과+배+재배면적조사+결과.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055605754efc196df846bba239e4206d6e070d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630965868,
      entryDate: 1761630965000,
      syncId: "20251028055458c6b0379de5cd40489aec615b4936f41d",
      documnetName: "한국표준산업분류+제11차+개정+보도자료(최종안).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055605ad662d226526444ebf0fe3e3008185a7",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630965184,
      entryDate: 1761630965000,
      syncId: "202510280554586bc5c09bbf50422b942e99aeb99af516",
      documnetName: "2023년+맥류+봄감자+사과+배+재배면적조사+결과 (1).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556043e1919eec15a4e309d8ba15662ae44e3",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630964586,
      entryDate: 1761630964000,
      syncId: "20251028055458e9f086580f4e4fb4a3c9847eba1fbf22",
      documnetName:
        "2022년+통계업무+진흥유공(통계조사+부문)+포상수여식(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556049eb6dc25d25948aea1e359ab1903fb93",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630964119,
      entryDate: 1761630964000,
      syncId: "2025102805545837023de4c762400d9665b61c9f5348be",
      documnetName:
        "[통계청]+통계청+수출+빅데이터+제공+및+해외통계데이터+수집+제공으로+기업+지원+가속화(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556038a5a3b6580554a0aaf55c47648ee9f30",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630963634,
      entryDate: 1761630963000,
      syncId: "202510280554583b52161935a742628ea4170536f7bdee",
      documnetName: "2023년+가을배추+무+재배면적조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556037d09b54607c9492fb5812b1e239da2de",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630963163,
      entryDate: 1761630963000,
      syncId: "202510280554580b1faa6d4a33401688009e11cdce4da2",
      documnetName: "보도자료(제22회+통계청+논문+공모전+개최).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556024ac29f3210f44d2fbc08491a615475c2",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630962677,
      entryDate: 1761630962000,
      syncId: "2025102805545802d7d653365a4d42a528214b02c11a23",
      documnetName: "2023년+벼+고추+재배면적조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055602ae81e9f19c094a0b8f0bb259de1183e3",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630962169,
      entryDate: 1761630962000,
      syncId: "202510280554587d1e30c2b585449c83d78255b920b8e1",
      documnetName: "ssec2310(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055601a31d12a47a734c7682e6df3ab3ea32d1",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630961675,
      entryDate: 1761630961000,
      syncId: "20251028055458c7e03f01083549289d1cfc4aeaee7f11",
      documnetName: "ssec2311(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280556019ffdcae1e56d44fc94ef58662817df2e",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630961183,
      entryDate: 1761630961000,
      syncId: "20251028055458a6c24ddc65b242e5b80c1851cd522fcc",
      documnetName: "ssec2401(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055600df45bb803546466da89ec153b6034ab7",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630960686,
      entryDate: 1761630960000,
      syncId: "2025102805545824461bc50fdc4b1e95e9fe3f635e9c74",
      documnetName: "wordtopdffile.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055600c22dab9d290e4d0d9867852d996a2892",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630960195,
      entryDate: 1761630960000,
      syncId: "2025102805545893e6ca2c1212414c86426f4ac450d691",
      documnetName: "file-sample_150kB.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055559ba5c574d807a48d48610a3ddd90d797e",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630959658,
      entryDate: 1761630959000,
      syncId: "20251028055458263051ff82274f8781874fb286842b6e",
      documnetName: "ssec2402(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055559bf30fd39c2d7427f992c3f988de4b965",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630959205,
      entryDate: 1761630959000,
      syncId: "2025102805545826d9b1319fc6434a935cd45ea474be24",
      documnetName: "ssec2309(통계표).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055558e07d5dd03dc94cbfa889693ee57fa191",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630958755,
      entryDate: 1761630958000,
      syncId: "20251028055458138e5533122f481da9be5de0a15717e7",
      documnetName: "분기+GRDP+개발_정책홍보+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555585f7566d89e1042948ab46c1a34023499",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630958301,
      entryDate: 1761630958000,
      syncId: "202510280554587e3bbbcc64284e14aa27eaf18f264219",
      documnetName: "종로구관철동프라움스테이_주택사진.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055557e49b10a92028428caf4e198f06ed33cd",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630957837,
      entryDate: 1761630957000,
      syncId: "2025102805545851c2b2631fa64d7c88a338d4b45c8168",
      documnetName: "보도자료(KOSTAT+통계플러스+겨을호+발간+사전+배포).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055557098c0d3bf8e94987af4a850ed6bb02a9",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630957362,
      entryDate: 1761630957000,
      syncId: "20251028055458d70801e1ff1b4b1dbc5ca0fc2fa6d7a7",
      documnetName:
        "지방소멸+대응을+위한+지역+인구+100년+추계+제공+보도자료.pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055556e730db54fb5a471bb2ac736eee92d1c8",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "document",
      logTypeDbValue: "document",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630956906,
      entryDate: 1761630956000,
      syncId: "2025102805545854087ede25f648f5bd0ce34ebbdc46f1",
      documnetName:
        "통계청.+국가통계+특화형+개인정보+안심구역+운영한다(보도자료).pdf",
      result: null,
      status: null,
      saveType: 0,
      historyType: 1,
      revisionNo: 1,
      desc: null,
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: null,
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055515ee370877ad4147918ce8018c6a421d8f",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630915152,
      entryDate: 1761630915000,
      syncId: "20251028055458138e5533122f481da9be5de0a15717e7",
      documnetName: "분기+GRDP+개발_정책홍보+보도자료.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "분기+GRDP+개발_정책홍보+보도자료.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "d6f392e74b8a4a29a18fd965c898b1cb",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "20251028055458138e5533122f481da9be5de0a15717e7",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055514ebe6ea2cd80f4b4d861dd4353bef9ab3",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630914945,
      entryDate: 1761630914000,
      syncId: "202510280554587e3bbbcc64284e14aa27eaf18f264219",
      documnetName: "종로구관철동프라움스테이_주택사진.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "종로구관철동프라움스테이_주택사진.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "c3573ed80fcf442088a859d5b82c2a22",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "202510280554587e3bbbcc64284e14aa27eaf18f264219",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055514015ce8094a2d42b9b5f77fcc57209e63",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630914777,
      entryDate: 1761630914000,
      syncId: "202510280554583b52161935a742628ea4170536f7bdee",
      documnetName: "2023년+가을배추+무+재배면적조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "2023년+가을배추+무+재배면적조사+결과+보도자료.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "e07a5cb6718d48ba98fe810eef0d0939",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "202510280554583b52161935a742628ea4170536f7bdee",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555140d4d1751ec75488ea4c0fbac30d20612",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630914602,
      entryDate: 1761630914000,
      syncId: "2025102805545824461bc50fdc4b1e95e9fe3f635e9c74",
      documnetName: "wordtopdffile.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "wordtopdffile.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "15d6ee66d2814018b6bfced19c428466",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "2025102805545824461bc50fdc4b1e95e9fe3f635e9c74",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555141ebf9bcd3f1546b2bb34e2047adf2b4d",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630914433,
      entryDate: 1761630914000,
      syncId: "20251028055458263051ff82274f8781874fb286842b6e",
      documnetName: "ssec2402(통계표).pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "ssec2402(통계표).pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "4bc79012997d443486c96a6ab9e31517",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "20251028055458263051ff82274f8781874fb286842b6e",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055514c713c808ef034d8bb856e4f87a6a4606",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630914269,
      entryDate: 1761630914000,
      syncId: "2025102805545893e6ca2c1212414c86426f4ac450d691",
      documnetName: "file-sample_150kB.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "file-sample_150kB.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "750cec394ead43cc9ebbdcea6a51bdd3",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "2025102805545893e6ca2c1212414c86426f4ac450d691",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555144b5acffc1321490a99cc9e5e8de3f71a",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630914107,
      entryDate: 1761630914000,
      syncId: "202510280554584715bff0b3cf4c1b9bc09173ac13f878",
      documnetName: "2023년+맥류+봄감자+사과+배+재배면적조사+결과.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "2023년+맥류+봄감자+사과+배+재배면적조사+결과.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "a658a3adcd0c4a1699af6723aa1e5c65",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "202510280554584715bff0b3cf4c1b9bc09173ac13f878",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555139fa58aec42cb4b02991d25a9c58fee97",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630913940,
      entryDate: 1761630913000,
      syncId: "2025102805545928e8493f37464567965dc09b3993ddc9",
      documnetName:
        "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료).pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료).pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "890acd7c98af4ec081a90b3c9dfd54b1",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "2025102805545928e8493f37464567965dc09b3993ddc9",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "2025102805551321e6e0e452d7460d9ba127ae979b3b32",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630913776,
      entryDate: 1761630913000,
      syncId: "20251028055458c6b0379de5cd40489aec615b4936f41d",
      documnetName: "한국표준산업분류+제11차+개정+보도자료(최종안).pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "한국표준산업분류+제11차+개정+보도자료(최종안).pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "09cc8da7ac474cc296212d3f81c1faf9",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "20251028055458c6b0379de5cd40489aec615b4936f41d",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055513fbeb506bcd154a15ada27ec6af149124",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630913596,
      entryDate: 1761630913000,
      syncId: "20251028055459417f0a554d814b72bfa69b6562a922d1",
      documnetName: "2023년+봄감자+생산량조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "2023년+봄감자+생산량조사+결과+보도자료.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "88af225f27e948a982e749038bb2dcab",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "20251028055459417f0a554d814b72bfa69b6562a922d1",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "202510280555139fe1a66eaa8d41098ee89e31b6739d1e",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630913429,
      entryDate: 1761630913000,
      syncId: "2025102805545802d7d653365a4d42a528214b02c11a23",
      documnetName: "2023년+벼+고추+재배면적조사+결과+보도자료.pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "2023년+벼+고추+재배면적조사+결과+보도자료.pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "ec2e20c733ce401184c1f6b91705ae2f",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "2025102805545802d7d653365a4d42a528214b02c11a23",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
    {
      logId: "20251028055513b8f7f862da7f4c64af68a45615139fce",
      userId: "eco_admin",
      userName: "eco_Administrator",
      workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
      workgroupName: "ddd",
      logType: "documentRole",
      logTypeDbValue: "documentRole",
      actionType: "add",
      actionTypeDbValue: "add",
      logDatas: null,
      logData: null,
      logDate: 1761630913274,
      entryDate: 1761630913000,
      syncId: "20251028055459df54d1aa5ddd45d4a9449c7711007d73",
      documnetName:
        "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료) (1).pdf",
      result: null,
      status: null,
      saveType: 9,
      historyType: 1,
      revisionNo: 1,
      desc: "국민+삶에+통계를+한걸음+더+가까이+국가통계포털(KOSIS)(보도자료) (1).pdf",
      ip: "110.11.32.50",
      agentType: 3,
      agentVersion: "Windows-Chrome-141.0.0.0",
      policyLogs: [
        {
          title: null,
          permissionPolicy: {
            changeCode: "CREATE",
            uniqueId: "724cb7514431430285918acc760c78bb",
            workgroupCode: "817825cf899b4bc38f8ccd8dadff6c1a",
            syncId: "20251028055459df54d1aa5ddd45d4a9449c7711007d73",
            targetType: "WORKGROUP",
            targetValue: "817825cf899b4bc38f8ccd8dadff6c1a",
            authType: "LOGIN",
            policyType: "DOCUMENT",
            policyCode: "f7ee0780386e44cf9a9f4f47cb1af219",
            updateTime: 0,
            createUser: "eco_admin",
            updateUser: "eco_admin",
            policy: {
              startTime: 1760502406428,
              allowDays: -1,
              allowDaysTimeZone: 9,
              allowViewCount: 0,
              currentViewCount: 0,
              allowDownloadCount: 0,
              currentDownloadCount: 0,
              drmPerm: ["view"],
              webView: true,
              revision: true,
              download: true,
              wrapping: true,
              additionalViewPermission: "NONE",
              fileShareLinkPolicy: {
                authType: "NONE",
                password: "",
                urlAction: "WEBUSING_AND_DOWNLOAD",
                allowDays: -1,
                allowDaysTimeZone: 9,
              },
              notificationPolicy: {
                usingWorkgroupInvitedAlert: false,
                usingFileAlert: true,
                fileAlert: ["fileshare", "memo", "revision"],
                usingReadRequestAlert: true,
                readRequestAlert: ["readRequestConfirm", "readRequest"],
              },
            },
          },
        },
      ],
      userType: 1,
      chatLogData: null,
      prevLogData: null,
    },
  ],
  total: 365,
  logId: null,
  lastLogId: "20251028055513b8f7f862da7f4c64af68a45615139fce",
  pageTotal: 50,
  posPage: 1,
  pageRange: 1,
  rowRange: 50,
};
const workgroup_tree = [
  {
    dsdCode: null,
    workgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    workgroupName: "3월의 스크린샷",
    desc: "워크그룹 설명추가함요",
    managerId: "parkyw1206",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 4,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1752214244595,
    updateDate: 1759214353047,
    isValidate: 1,
    docSize: 0,
    docCount: 19,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "e7bcef0b074749efac005bddd57fcaad",
    workgroupName: "4월9일-2",
    desc: "",
    managerId: "bkseo2",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1744172542463,
    updateDate: 1749085888451,
    isValidate: 1,
    docSize: 0,
    docCount: 27,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "3a9bcd0bb50a4c96a057a4822bce8daf",
    rootWorkgroupId: "3a9bcd0bb50a4c96a057a4822bce8daf",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "9fba6ccb50c94f638a14958578d4b983",
    workgroupName: "d",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 4,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753173966858,
    updateDate: 1760664543910,
    isValidate: 1,
    docSize: 0,
    docCount: 19,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "9fba6ccb50c94f638a14958578d4b983",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "817825cf899b4bc38f8ccd8dadff6c1a",
    workgroupName: "ddd",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "Y",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 6,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1749701841296,
    updateDate: 1761524149277,
    isValidate: 1,
    docSize: 0,
    docCount: 73,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "c35ffe05b8a947a8a232f33e937914c0",
    rootWorkgroupId: "c35ffe05b8a947a8a232f33e937914c0",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "3a9bcd0bb50a4c96a057a4822bce8daf",
    workgroupName: "eCo_30_WG_TEST1",
    desc: null,
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761094895306,
    updateDate: 1761702048809,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "3a9bcd0bb50a4c96a057a4822bce8daf",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "7c026ca73a1f491fa21a7797e9f6d5b0",
    workgroupName: "eCo_30_WG_TEST1-2",
    desc: "ddddddd",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761095171867,
    updateDate: 1761116738399,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    rootWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "f0fab92b919440619a828ea795c92630",
    workgroupName: "eCo_30_WG_TEST1-3",
    desc: "ddddddd",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761095858610,
    updateDate: 1761116777657,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "f0fab92b919440619a828ea795c92630",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "cfc295c6abfa4e4d9e8da357843dceb6",
    workgroupName: "eCo_30_WG_TEST1-4",
    desc: null,
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761096196650,
    updateDate: 1761096196650,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "2d68c40f6323423abb2f21b653bc5cf8",
    rootWorkgroupId: "2d68c40f6323423abb2f21b653bc5cf8",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "34a6c2fd155c49ada18862c53914737c",
    workgroupName: "eCo_30_WG_TEST1-4-1",
    desc: null,
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761096243193,
    updateDate: 1761096243193,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "dfa5c588059c4a5ea76778b92f27c707",
    rootWorkgroupId: "dfa5c588059c4a5ea76778b92f27c707",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "f0294222400d4716a8b3e82f28951a4e",
    workgroupName: "eCo_30_WG_TEST2",
    desc: null,
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761109930618,
    updateDate: 1761109930618,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "b62401003c4047979660dbf37667a6cd",
    rootWorkgroupId: "b62401003c4047979660dbf37667a6cd",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    workgroupName: "eCo_30_WG_TEST2-1",
    desc: null,
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761699421550,
    updateDate: 1761699421550,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "5fd9ad693769495fa790ce2f02e404c0",
    workgroupName: "html wrapping test",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 1,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1757491062708,
    updateDate: 1757491091957,
    isValidate: 1,
    docSize: 0,
    docCount: 4,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "5fd9ad693769495fa790ce2f02e404c0",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "b3a223565df9462cadf1799f6e9251d6",
    workgroupName: "htmlWrappingTest_WG",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 3,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1760924739278,
    updateDate: 1760924739279,
    isValidate: 1,
    docSize: 0,
    docCount: 3,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "5fd9ad693769495fa790ce2f02e404c0",
    rootWorkgroupId: "5fd9ad693769495fa790ce2f02e404c0",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "eee30ee8f4c744409bc440abc06e6c12",
    workgroupName: "mhkang",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753343875542,
    updateDate: 1753343875542,
    isValidate: 1,
    docSize: 0,
    docCount: 2,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "7c026ca73a1f491fa21a7797e9f6d5b0",
    rootWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "03ac67bfd2324c44b9b01733c862edd8",
    workgroupName: "newRequestTest",
    desc: "test1234333ddfdgdsffdsgsdfgdd",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761211797078,
    updateDate: 1761212153427,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "e7bcef0b074749efac005bddd57fcaad",
    rootWorkgroupId: "3a9bcd0bb50a4c96a057a4822bce8daf",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "dfa5c588059c4a5ea76778b92f27c707",
    workgroupName: "newRequestTest1-1",
    desc: "testdd",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761718101051,
    updateDate: 1761719507973,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "dfa5c588059c4a5ea76778b92f27c707",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "2d68c40f6323423abb2f21b653bc5cf8",
    workgroupName: "outlook (new) test",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753352096578,
    updateDate: 1753352096578,
    isValidate: 1,
    docSize: 0,
    docCount: 7,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "2d68c40f6323423abb2f21b653bc5cf8",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    workgroupName: "sssssss",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 3,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1754381316551,
    updateDate: 1754381316551,
    isValidate: 1,
    docSize: 0,
    docCount: 1,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "1f176d7346814c4393697035110b40af",
    workgroupName: "teseyt1",
    desc: "",
    managerId: "jh.min1",
    managerName: null,
    favorite: "Y",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 4,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1742455340072,
    updateDate: 1749112270380,
    isValidate: 1,
    docSize: 0,
    docCount: 19,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    rootWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "9627bce3589c4d47a826f829cba115ef",
    workgroupName: "test11",
    desc: "",
    managerId: "jh.min",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 4,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1744245055998,
    updateDate: 1751259589087,
    isValidate: 1,
    docSize: 0,
    docCount: 6,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "c816367fcbc14dca9818978247f25502",
    rootWorkgroupId: "c816367fcbc14dca9818978247f25502",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "8891f1d01a944f9b9403f3781cc32235",
    workgroupName: "w0",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1754457640536,
    updateDate: 1754457640536,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "b62401003c4047979660dbf37667a6cd",
    rootWorkgroupId: "b62401003c4047979660dbf37667a6cd",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "e03a598b8b2a48d98960b394f1fc99c1",
    workgroupName: "wg create test",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761199602091,
    updateDate: 1761199602091,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "dfa5c588059c4a5ea76778b92f27c707",
    rootWorkgroupId: "dfa5c588059c4a5ea76778b92f27c707",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "4c808ccb8d1b4de98ef9a4193d6f34f2",
    workgroupName: "ww",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753168098063,
    updateDate: 1753329063808,
    isValidate: 1,
    docSize: 0,
    docCount: 3,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "cfc295c6abfa4e4d9e8da357843dceb6",
    rootWorkgroupId: "2d68c40f6323423abb2f21b653bc5cf8",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "5f862846a15a49d29c6dd5e30dfed8c2",
    workgroupName: "www",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1754274292046,
    updateDate: 1754274292046,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "d39d9de50b874a0ba1791b6d84afc791",
    rootWorkgroupId: "d39d9de50b874a0ba1791b6d84afc791",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "57b5356067fb4c7aa67c007980ee1cfa",
    workgroupName:
      "yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!yes!",
    desc: "wqweqweqwqweqweqwqweqweqwqweqweqwqweqweqwqweqweqwqweqweqwqweqweqwqweqeqwqweqweqwqweqweqwqweqweqwqweqweqwqweqweqwqweqweq",
    managerId: "parkyw1206",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 4,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1742875404486,
    updateDate: 1753921746993,
    isValidate: 1,
    docSize: 0,
    docCount: 57,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    rootWorkgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "c35ffe05b8a947a8a232f33e937914c0",
    workgroupName: "ㄴㅁㅁ",
    desc: "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 5,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1744245091948,
    updateDate: 1753319853637,
    isValidate: 1,
    docSize: 0,
    docCount: 35,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "c35ffe05b8a947a8a232f33e937914c0",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "c816367fcbc14dca9818978247f25502",
    workgroupName: "내부사용자에게 열람을 허용할거에용",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 3,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753851949152,
    updateDate: 1753851949152,
    isValidate: 1,
    docSize: 0,
    docCount: 2,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "c816367fcbc14dca9818978247f25502",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "b62401003c4047979660dbf37667a6cd",
    workgroupName: "노트북은 작지않다",
    desc: "ab",
    managerId: "parkyw1206",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: 1767797999999,
    logDate: 1751862241476,
    updateDate: 1752576977489,
    isValidate: 1,
    docSize: 0,
    docCount: 6,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "b62401003c4047979660dbf37667a6cd",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "707876db8f844e4ba8f675f2acb0cd87",
    workgroupName: "미가입 사용자 초대",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1754379819680,
    updateDate: 1754435536621,
    isValidate: 1,
    docSize: 0,
    docCount: 1,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    rootWorkgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "610b2c6e84da4ac2b7ed7a87a190f3a0",
    workgroupName: "복사긴급테스트!",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 1,
    internalUserCount: 3,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753749764375,
    updateDate: 1754381688197,
    isValidate: 1,
    docSize: 0,
    docCount: 4,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    rootWorkgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "796cb11881b84a66964cd66894385c22",
    workgroupName: "안길다근데길다",
    desc: "안긴 워크그룹인데 사실은 긴 워크그룹이면 어쩌죠? 안긴 워크그룹인데 사실은 긴 워크그룹이면 어쩌죠? 안긴 워크그룹인데 사실은 긴 워크그룹이면 어쩌죠? 안긴 워크그룹인데 사실은 긴 워크그룹이면 어쩌죠? 안긴 워크그룹인",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 3,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1749515229725,
    updateDate: 1751507284700,
    isValidate: 1,
    docSize: 0,
    docCount: 23,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "f0fab92b919440619a828ea795c92630",
    rootWorkgroupId: "f0fab92b919440619a828ea795c92630",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "96abb13e1fc14e6680efe840a4683937",
    workgroupName: "애드인 테스트",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1760593146357,
    updateDate: 1760593146357,
    isValidate: 1,
    docSize: 0,
    docCount: 6,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "7c026ca73a1f491fa21a7797e9f6d5b0",
    rootWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "04c4fc6fc7434bf8933d4ab0b05ce752",
    workgroupName: "외부사용자자s",
    desc: "sssddds",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 2,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: 1753369199999,
    logDate: 1750327217576,
    updateDate: 1753329601190,
    isValidate: 0,
    docSize: 0,
    docCount: 7,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "707876db8f844e4ba8f675f2acb0cd87",
    rootWorkgroupId: "19e98ad7cb30471596f3e7ee2bef1db0",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: false,
  },
  {
    dsdCode: null,
    workgroupId: "36a573ef921e4652adedf505b084295c",
    workgroupName: "외부사용자초대테스트",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 2,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1761540405474,
    updateDate: 1761540432398,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "7c026ca73a1f491fa21a7797e9f6d5b0",
    rootWorkgroupId: "561254a5c9d044d3a9ebb17b92a04903",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "66984e76824345e5b91f573d2918c119",
    workgroupName: "외부사용자테스트WG",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 2,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1756339435522,
    updateDate: 1756341856611,
    isValidate: 1,
    docSize: 0,
    docCount: 0,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "f0fab92b919440619a828ea795c92630",
    rootWorkgroupId: "f0fab92b919440619a828ea795c92630",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "f01fb2b9a0464eb98adf0c6f6e5cecff",
    workgroupName: "워크그룹 이름을 입력하세요.",
    desc: "",
    managerId: "jh.min",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 3,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753316785354,
    updateDate: 1756345397057,
    isValidate: 1,
    docSize: 0,
    docCount: 22,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "f01fb2b9a0464eb98adf0c6f6e5cecff",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "40513efce1ea419fa482b23827c52b8c",
    workgroupName: "유효기간 없음",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1755042032555,
    updateDate: 1755042032555,
    isValidate: 1,
    docSize: 0,
    docCount: 7,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "f01fb2b9a0464eb98adf0c6f6e5cecff",
    rootWorkgroupId: "f01fb2b9a0464eb98adf0c6f6e5cecff",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "fa0bc040fb5140888d327d40acf11de0",
    workgroupName:
      "이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!이력이 많은 워크그룹!",
    desc: "뮤뮤뮤ㅇㅇdddss22222222222222222",
    managerId: "jh.min",
    managerName: null,
    favorite: "Y",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 1,
    internalUserCount: 10,
    status: 1,
    startDate: -1,
    endDate: 1845989999999,
    logDate: 1742454163187,
    updateDate: 1752227671307,
    isValidate: 1,
    docSize: 0,
    docCount: 55,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "610b2c6e84da4ac2b7ed7a87a190f3a0",
    rootWorkgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "bde88772a8194711992f904636121979",
    workgroupName: "일반 테스트",
    desc: "12341234",
    managerId: "eco_admin",
    managerName: null,
    favorite: "Y",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 5,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753312531527,
    updateDate: 1761539446111,
    isValidate: 1,
    docSize: 0,
    docCount: 17,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    rootWorkgroupId: "fcb5fab2201146d4bc659508b6f342b9",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: false,
  },
  {
    dsdCode: null,
    workgroupId: "a4a7e06e3b9d46869f331a72d4ff49e3",
    workgroupName: "초대용s",
    desc: "test",
    managerId: "jh.min",
    managerName: null,
    favorite: "Y",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1749038377392,
    updateDate: 1749435055765,
    isValidate: 1,
    docSize: 0,
    docCount: 77,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "8891f1d01a944f9b9403f3781cc32235",
    rootWorkgroupId: "b62401003c4047979660dbf37667a6cd",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: false,
  },
  {
    dsdCode: null,
    workgroupId: "24b7d79ee89f4d6088b7a8725ce19d69",
    workgroupName:
      "최대한 많은 분들을 초대한 워크그룹입니다. 화상회의 테스트좀 해볼게요..!",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "Y",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 11,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1749467407078,
    updateDate: 1749467407078,
    isValidate: 1,
    docSize: 0,
    docCount: 1,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: "5cfbc17e8661429fbab3e08462a2400a",
    rootWorkgroupId: "5cfbc17e8661429fbab3e08462a2400a",
    hasSubWorkgroup: false,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "d39d9de50b874a0ba1791b6d84afc791",
    workgroupName: "추추",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 1,
    internalUserCount: 1,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1754381958928,
    updateDate: 1754381958928,
    isValidate: 1,
    docSize: 0,
    docCount: 1,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "d39d9de50b874a0ba1791b6d84afc791",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
  {
    dsdCode: null,
    workgroupId: "5cfbc17e8661429fbab3e08462a2400a",
    workgroupName: "힝구",
    desc: "",
    managerId: "eco_admin",
    managerName: null,
    favorite: "N",
    members: null,
    withdrawMembers: null,
    invitePolicy: 0,
    externalUserCount: 0,
    internalUserCount: 2,
    status: 1,
    startDate: -1,
    endDate: -1,
    logDate: 1753855510181,
    updateDate: 1753856007328,
    isValidate: 1,
    docSize: 0,
    docCount: 1,
    readRequestCount: 0,
    webMeetingCount: 0,
    chatCount: 0,
    parentWorkgroupId: null,
    rootWorkgroupId: "5cfbc17e8661429fbab3e08462a2400a",
    hasSubWorkgroup: true,
    workgroupType: "GENERAL",
    workgroupJoined: true,
  },
];
const getTreeWorkgroup = () => {
  // CRA에서는 핫리로드 때 모듈이 리셋되므로 window 전역에 저장
  if (!(window as any).__workgroup_tree__) {
    (window as any).__workgroup_tree__ = workgroup_tree;
  }
  return (window as any).__workgroup_tree__;
};
const getConfigStore = () => {
  // CRA에서는 핫리로드 때 모듈이 리셋되므로 window 전역에 저장
  if (!(window as any).__config_data__) {
    (window as any).__config_data__ = config_data;
  }
  return (window as any).__config_data__;
};
const getDashboardLicense = () => {
  // CRA에서는 핫리로드 때 모듈이 리셋되므로 window 전역에 저장
  if (!(window as any).__dashboard_license__) {
    (window as any).__dashboard_license__ = {
      externalLicenseCount: 100,
      internalLicenseCount: 50,
      liteExternalLicenseCount: 200, // OTP 사용자 (0인 경우 사용 안함)
      usedExternalCount: 8,
      usedInternalCount: 31,
      usedLiteExternalCount: 150, // 사용중인 OTP 사용자
      allowMobile: true,
      allowMacOS: true,
      allowWebView: true,
    };
  }
  return (window as any).__dashboard_license__;
};
const getFileUsageAdminLogStore = () => {
  // CRA에서는 핫리로드 때 모듈이 리셋되므로 window 전역에 저장
  if (!(window as any).__file_usage_admin_log__) {
    (window as any).__file_usage_admin_log__ = file_usage_admin_log;
  }
  return (window as any).__file_usage_admin_log__;
};
const getFileUsageUserLogStore = () => {
  // CRA에서는 핫리로드 때 모듈이 리셋되므로 window 전역에 저장
  if (!(window as any).__file_usage_user_log__) {
    (window as any).__file_usage_user_log__ = file_usage_user_log;
  }
  return (window as any).__file_usage_user_log__;
};
export const handlers = [
  // http.get(rx("/eco-gateway/wapi/admins/config"), async () => {
  //   await delay(150); // 선택: 네트워크 지연 흉내
  //   const config_data = getConfigStore();

  //   return HttpResponse.json(config_data, { status: 200 });
  // }),
  // http.post(rx("/eco-gateway/wapi/admins/config"), async ({ request }) => {
  //   await delay(150); // 선택: 네트워크 지연 흉내
  //   const body = await request.json().catch(() => ({})); // JSON이 아닐 수도 있으니 안전하게
  //   const config_data = getConfigStore();
  //   Object.assign(config_data, body); // 값 덮어쓰기
  //   return HttpResponse.json(config_data, { status: 200 });
  // }),

  // http.get(
  //   // syncId가 어떤 문자열이든 매칭
  //   /\/eco-gateway\/papi\/file\/detail\/([^/]+)$/,
  //   async () => {
  //     return HttpResponse.json(
  //       {
  //         contentName: "week_export.csv",
  //         fileSize: 1856,
  //         master: {
  //           userId: "jh.min3",
  //           userName: "민주희3",
  //         },
  //       },
  //       { status: 200 }
  //     );
  //   }
  // ),
  // http.post(
  //   rx("/eco-gateway/wapi/admins/logs/new/paging"),
  //   async ({ request }) => {
  //     const body: any = await request.json().catch(() => ({})); // JSON이 아닐 수도 있으니 안전하게
  //     if ((body as any).posPage > 1) {
  //       passthrough();
  //       return;
  //     }
  //     await delay(150); // 선택: 네트워크 지연 흉내
  //     const log = getFileUsageAdminLogStore();
  //     if (body.workgroupIdList.length === 0)
  //       return HttpResponse.json(log, { status: 200 });
  //     else {
  //       console.log(log);

  //       const returnLog = {
  //         ...log,
  //         logResults: log.logResults.filter((item: any) =>
  //           body.workgroupIdList.includes(item.workgroupId)
  //         ),
  //       };
  //       console.log(returnLog);
  //       return HttpResponse.json(returnLog, { status: 200 });
  //     }
  //   }
  // ),
  http.post(
    rx("/eco-gateway/wapi/logs/new/paging/contents/me"),
    async ({ request }) => {
      const body: any = await request.json().catch(() => ({})); // JSON이 아닐 수도 있으니 안전하게
      if ((body as any).posPage > 1) {
        passthrough();
        return;
      }
      await delay(150); // 선택: 네트워크 지연 흉내
      const log = getFileUsageUserLogStore();
      if (body.workgroupIdList.length === 0)
        return HttpResponse.json(log, { status: 200 });
      else {
        const returnLog = {
          ...log,
          logResults: log.logResults.filter((item: any) =>
            body.workgroupIdList.includes(item.workgroupId)
          ),
        };
        console.log(returnLog);
        return HttpResponse.json(returnLog, { status: 200 });
      }
    }
  ),
  // http.get(rx("/eco-gateway/wapi/workgroups/tree"), async () => {
  //   await delay(150); // 선택: 네트워크 지연 흉내
  //   const tree_workgroup = getTreeWorkgroup();
  //   return HttpResponse.json(tree_workgroup, { status: 200 });
  // }),
  // http.get(rx("/eco-gateway/wapi/admins/dashboard/license"), async () => {
  //   await delay(150); // 선택: 네트워크 지연 흉내
  //   const license = getDashboardLicense();
  //   return HttpResponse.json(license, { status: 200 });
  // }),
  http.post(
    rx("/eco-gateway/wapi/admins/users/list/external/lite"),
    async () => {
      await delay(150); // 선택: 네트워크 지연 흉내
      const users = [
        {
          userId: "mzooh1112@naver.com",
          userName: "외부민주희네이버",
          userType: 3,
          status: null,
          updatedTime: 0,
          registedTime: 1761540626978,
          deletedTime: 0,
        },
        {
          userId: "bk.seo@fasoo.com",
          userName: "외부보경",
          userType: 3,
          status: null,
          updatedTime: 1760916909610,
          registedTime: 1754278209327,
          deletedTime: 0,
        },
      ];
      return HttpResponse.json(users, { status: 200 });
    }
  ),
];
